import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "px-2" }, " % ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtnGroup = _resolveComponent("BalBtnGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BalBtnGroup, {
      options: _ctx.options,
      modelValue: _ctx.fixedSlippage,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_ctx.fixedSlippage = $event)),
        _ctx.onFixedInput
      ]
    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
    _createElementVNode("div", {
      class: _normalizeClass([
        'flex items-center px-1 rounded-lg shadow-inner',
        {
          'border border-blue-500 text-blue-500': !_ctx.isFixedSlippage,
          'border dark:border-gray-900': _ctx.isFixedSlippage
        }
      ])
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "w-12 text-right bg-transparent",
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.customSlippage = $event)),
          _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCustomInput && _ctx.onCustomInput(...args)))
        ],
        placeholder: "0.1",
        type: "number",
        step: "any",
        min: "0"
      }, null, 512), [
        [_vModelText, _ctx.customSlippage]
      ]),
      _hoisted_2
    ], 2)
  ]))
}